/* eslint-disable react-hooks/exhaustive-deps */
// eslint-disable-next-line import/no-extraneous-dependencies
/* eslint-disable */

import html2canvas from "html2canvas";
import React, { act, useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Style from "../assets/css/main.module.css";
import parkImage from "../assets/images/park.svg";
import useS3File from "../library/S3Services";
import { drawerAction } from "../store/features/deviceSlice";
import Header from "../components/nav/Header";
import useAuthWatcher from "../hooks/useAuthWatcher";

const tickets = Array(16).fill({
  ticketId: "JFE4001",
  ticketName: "Shohoz Test",
  ticketType: "Entry",
  expiryDate: "24/02/2024",
  price: "100",
  qrSrc:
    "https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=JFE4001", // Placeholder QR
});

export default function PrintTicket() {
  const navigate = useNavigate();

  const { bookingId } = useParams();

  const [paymentData, setPaymentData] = useState(null);

  useEffect(() => {
    let paymentDataRes = null;

    try {
      paymentDataRes = JSON.parse(sessionStorage.getItem(`pdr_${bookingId}`));
    } catch (err) {
      console.error("Error parsing payment data. Error: ", err);
    }

    if (paymentDataRes) {
      setPaymentData(paymentDataRes);
    } else {
      navigate("/");
    }
  }, [bookingId, navigate]);

  const dispatch = useDispatch();

  const [duplicate, setDuplicate] = useState(false);

  const [userData, setUserData] = useState({
    firstName: "Anoy",
    lastName: "Chowdhury",
    mobile: "01700000000",
  });

  // const { state } = useLocation();

  const [state, setState] = useState({
    type: "general",
    action: "print", // or "download"
    data: {
      tickets: [
        {
          purchased: ["TICKET-001", "TICKET-002", "TICKET-003", "TICKET-004"],
          type: "nice",
          name: "Babuland",
          expiry: "2024-12-31",
          babulandOrderId: 1909,
          branch: "Dhaka",
        },
        {
          purchased: [],
          type: "nice",
          name: "Wanderful Ticket",
          expiry: "2024-12-31",
          babulandOrderId: 1909,
          branch: "Dhaka",
        },
        {
          purchased: [],
          type: "nice",
          name: "Wanderful Ticket",
          expiry: "2024-12-31",
          babulandOrderId: 1909,
          branch: "Dhaka",
        },
        {
          purchased: [],
          type: "nice",
          name: "Wanderful Ticket",
          expiry: "2024-12-31",
          babulandOrderId: 1909,
          branch: "Dhaka",
        },
      ],
      id: 1000,
      details: {
        booking_on: "2023-10-01",
      },
    },
  });

  const qrRef = useRef(null);

  const ticketCounter = useRef(1);

  const { fileContent, loading } = useS3File(state?.data?.details?.park?.logo);

  const print = useReactToPrint({
    content: () => qrRef.current,
    onBeforePrint: () => {
      // Optionally add any preparation logic here
    },
    onAfterPrint: () => {
      // Optionally handle post-print logic here
    },
  });

  const download = () => {
    if (!duplicate) {
      if (qrRef.current) {
        setDuplicate(true);
        html2canvas(qrRef.current)
          .then((canvas) => {
            const dataUrl = canvas.toDataURL();
            const link = document.createElement("a");
            link.href = dataUrl;
            link.download = "tickets.png";
            link.click();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    }
  };

  useAuthWatcher(setUserData);

  useEffect(() => {
    if (!state) {
      navigate("/", { replace: true });
    } else {
      if (state?.action === "print" && !loading) {
        // print();
      }
      if (state?.action === "download" && !loading) {
        download();
      }
    }
  }, [state, navigate, print, loading]);

  useEffect(() => {
    dispatch(drawerAction(false));
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div
        className="container px-5 py-5 mt-5 rounded"
        style={{
          minWidth: "1100px",
          maxWidth: "1100px",
          background: "#fff",
          border: "3px solid #16a354",
        }}
      >
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <img
            src="https://shohoz.com/assets/img/shohoz_logo_new.png"
            alt="Shohoz"
            style={{ height: "40px" }}
          />
          <div className="text-end">
            <p className="mb-0">
              <div>
                Helpline{" "}
                <a
                  href="tel:16374"
                  className="text-success text-decoration-none fw-bold"
                >
                  16374
                </a>
              </div>
            </p>
            <p className="mb-0">
              Write us at{" "}
              <a
                className="text-success text-decoration-none fw-bold"
                href="mailto:info@shohoz.com"
              >
                info@shohoz.com
              </a>
            </p>
          </div>
        </div>

        {/* Title */}
        <div className="mb-4 fw-bold" style={{ fontSize: "24px" }}>
          e-Ticket for Jamuna Future Park
        </div>

        {/* Info Section */}
        <div
          className="row mb-4 p-3"
          style={{
            border: "2px solid #4cb87c",
            marginLeft: "0.3px",
            marginRight: "0.3px",
          }}
        >
          <div className="col-md-4" style={{ width: "321px" }}>
            <div>Park Name</div>
            <div className="mb-3 fw-semibold">{paymentData?.park}</div>
            <div>Branch:</div>
            <div className="mb-3 fw-semibold">{paymentData?.branch}</div>
            <div>Order ID:</div>
            <div className="fw-semibold">{paymentData?.pnr}</div>
          </div>
          <div className="col-md-4" style={{ width: "321px" }}>
            <div>Customer Name:</div>
            <div className="mb-3 fw-semibold">
              {paymentData?.customer?.first_name}{" "}
              {paymentData?.customer?.last_name}
            </div>
            <div>Customer Mobile No:</div>
            <div className="mb-3 fw-semibold">
              {paymentData?.customer?.phone}
            </div>
          </div>
          <div className="col-md-4" style={{ width: "321px" }}>
            <div>Booking Date:</div>
            <div className="mb-3 fw-semibold">
              {paymentData?.bookedOn?.split(" ")[0]}
            </div>
            <div>Total Price:</div>
            <div className="mb-3 fw-semibold">???</div>
          </div>
        </div>

        {/* Ticket Grid */}
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3 mb-4">
          {tickets.map((ticket, index) => (
            <div className="col" style={{ width: "253.8px" }} key={index}>
              <div
                className="p-3 h-100"
                style={{ border: "2px solid #4cb87c", fontSize: "14px" }}
              >
                <div className="mb-1 d-flex justify-content-between">
                  <div>Ticket ID</div>
                  <div className="fw-semibold">{ticket.ticketId}</div>
                </div>
                <div className="mb-1 d-flex justify-content-between">
                  <div>Ticket Name</div>
                  <div className="fw-semibold">{ticket.ticketName}</div>
                </div>
                <div className="mb-1 d-flex justify-content-between">
                  <div>Ticket type</div>
                  <div className="fw-semibold">{ticket.ticketType}</div>
                </div>
                <div className="mb-1 d-flex justify-content-between">
                  <div>Expiry Date</div>
                  <div className="fw-semibold">{ticket.expiryDate}</div>
                </div>
                <div className="mb-1 d-flex justify-content-between">
                  <div>Price</div>
                  <div className="fw-semibold">{ticket.price}</div>
                </div>
                <div className="mt-3">
                  <img
                    src={ticket.qrSrc}
                    alt="QR Code"
                    className="img-fluid mt-2"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* important information */}
        <div
          className="row"
          style={{
            marginLeft: "0.3px",
            marginRight: "0.3px",
          }}
        >
          <div
            className="col-6 p-0 border-end-0"
            style={{ border: "2px solid #4cb87c" }}
          >
            <div
              className="px-2 py-1 fw-bold"
              style={{ borderBottom: "2px solid #4cb87c" }}
            >
              Important Information
            </div>
            <div className="p-2">
              <ol className="list-unstyled">
                <li className="d-flex mb-1">
                  <div className="me-2">1.</div>
                  <div>This Ticket is not Transferable.</div>
                </li>
                <li className="d-flex mb-1">
                  <div className="me-2">2.</div>
                  <div>
                    A passenger may carry a maximum of 2 pieces of luggage, the
                    total weight of which should not exceed 35 kg. Each child
                    included in the ticket may carry additional 20 kg of
                    luggage. The maximum dimension allowed for each baggage is
                    22” x 18” x 9”. Penalty will be imposed for excess weight as
                    per railway rules.
                  </div>
                </li>
                <li className="d-flex mb-1">
                  <div className="me-2">3.</div>
                  <div>
                    Passengers are not allowed to carry any contraband items.
                    Any Poisonous/Toxic substance, Explosives, Firearms, etc.
                    are strictly prohibited.
                  </div>
                </li>
                <li className="d-flex mb-1">
                  <div className="me-2">4.</div>
                  <div>
                    Refund Deduction will be made as follows:- Before departure
                    of the train more than 120 hrs 25TK for the AC Class, 20TK
                    for the First Class, 15TK for the other Classes; Less than
                    120 hrs but more than 96 hrs for departure 50%; Less 96 hrs
                    but more than 72 hrs for departure 75%; and no refund for
                    less than 72 hrs or non reporting for Journey.
                  </div>
                </li>
              </ol>
            </div>
          </div>
          <div className="col-6 p-0" style={{ border: "2px solid #4cb87c" }}>
            <div
              className="px-2 py-1 fw-bold"
              style={{ borderBottom: "2px solid #4cb87c" }}
            >
              প্রয়োজনীয় তথ্য:
            </div>
            <div className="p-2">
              <ol className="list-unstyled">
                <li className="d-flex mb-1">
                  <div className="me-2">১.</div>
                  <div>টিকিট হস্তান্তর যোগ্য নয়|</div>
                </li>
                <li className="d-flex mb-1">
                  <div className="me-2">২.</div>
                  <div>
                    একজন যাত্রী সর্বোচ্চ ২টি ব্যাগেজ সঙ্গে নিতে পারবেন। মোট ওজন
                    ৩৫ কেজির বেশি হইবে না। টিকিটে অন্তর্ভুক্ত প্রতিটি শিশুর জন্য
                    অতিরিক্ত ২০ কেজি মালামাল নেয়া যাবে। ব্যাগেজের মাপ ২২” x ১৮”
                    x ৯” । অতিরিক্ত ওজনের জন্য বিধি অনুযায়ী মাশুল আদায়যোগ্য |
                  </div>
                </li>
                <li className="d-flex mb-1">
                  <div className="me-2">৩.</div>
                  <div>
                    কোন নিষিদ্ধ পণ্য সঙ্গে নেয়া যাবেনা। বিষাক্ত/মাদকদ্রব্য,
                    বিস্ফোরক, আগ্নেয়াস্ত্র ইত্যাদি বহন করা সম্পূর্ণ ভাবে
                    নিষিদ্ধ|
                  </div>
                </li>
                <li className="d-flex mb-1">
                  <div className="me-2">৪.</div>
                  <div>
                    টিকিট ফেরতের কর্তনযোগ্য মাশুল :- যাত্রার কমপক্ষে ১২০ ঘণ্টা
                    পূর্বে এসি শ্রেণিতে ২৫ টাকা, প্রথম শ্রেণিতে ২০ টাকা এবং
                    অন্যান্য শ্রেণিতে ১৫ টাকা |।যাত্রা আরম্ভের ১২০ ঘণ্টার কম ও
                    ৯৬ ঘণ্টার বেশি সময়ের ক্ষেত্রে ভাড়া ৫০%, যাত্রা আরম্ভের ৯৬
                    ঘণ্টার কম ও ৭২ ঘণ্টার বেশি সময়ের ক্ষেত্রে ভাড়া ৭৫% এবং ৭২
                    ঘণ্টার কম সময়ের ক্ষেত্রে অথবা যাত্রা না করলে কোন টিকিটের
                    মূল্য ফেরত হবে না|।
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container py-3 text-end"
        style={{ minWidth: "1100px", maxWidth: "1100px" }}
      >
        Powered By{" "}
        <span className="fw-semibold" style={{ color: "#079D49" }}>
          Shohoz
        </span>
      </div>
    </>
  );
}
